import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../utils/analytics";

/**
 * Sends a GA4 page_view on every client-side route change (and on first mount).
 * Base gtag config in public/index.html sets send_page_view: false so this is
 * the single source of page_view events for the SPA. Mount this once, inside
 * the router (see App.tsx).
 */
export const usePageTracking = (): void => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
};
